// The API charges before its slow post-payment work, so timing out early reports a paid request as failed.
export const PAYMENT_TIMEOUT_MS = 180000;

/**
 * Client timeout for every API call that does not set its own.
 *
 * ## Invariants:
 * - Two minutes, not the old 30 s. Why: the legacy reservation app sets NO client timeout at all
 *   (its shared axios instance is created with only a baseURL), so it simply waits for the api.
 *   30 s here reported slow-but-successful requests as failures across the app (PB 5068). 120 s is
 *   the bounded version of that legacy behaviour: it still ends a request that truly hangs.
 * - `PAYMENT_TIMEOUT_MS` must stay LONGER than this. Why: a money call that times out may already
 *   have charged the parker, so it is the one call that must never give up earlier than the rest.
 */
export const DEFAULT_API_TIMEOUT_MS = 120000;

/**
 * Timeout for api calls made while the server renders a page (root layout theme, refresh-token
 * login) or inside a Next.js route handler.
 *
 * ## Invariants:
 * - Stays at 30 s even though the browser default is now 120 s. Why: nothing is on screen until
 *   the server finishes, so a hanging api would hold EVERY page blank for the full default. These
 *   calls already fall back when they fail (the layout renders without a theme / signed out), so
 *   giving up sooner costs nothing and keeps a slow api from stalling the whole site.
 */
export const SERVER_RENDER_TIMEOUT_MS = 30000;
